/**
 * 主界面-后台任务
 * 创建时间：2017-07-10
 *   创建人：Shujuan Sun
 */
<template>
	<div id="mission-right-sidebar" style="height:auto;">
		<div class="vehicle-device-header">       
            <h4 class="ui-modal__header-text">后台任务</h4>
            <button type="button" class="close" @click="closeComp"><span >&times;</span></button>
        </div>
		<table class="table table-striped table-bordered">
			<thead>
				<tr>
					<th>任务ID</th>
					<th>任务名</th>
					<th>开始时间</th>
					<th>进度</th>
					<th>发起人</th>
					<th>状态</th>
					<th>操作</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(task,index) in taskList">
					<td>{{task.taskId}}</td>
					<td>{{task.taskName}}</td>
					<td>{{task.startTime}}</td>
					<td>{{task.progress}}</td>
					<td>{{task.createUserText}}</td>
					<td>{{task.taskStatusText}}</td>
					<td @click="stop(task.taskId)" v-if="task.taskStatus==0" class="hand"><a>{{task.taskStatusOperation}}</a></td>
					<td @click="download(task.urlToken)" v-if="task.taskStatus==1" class="hand"><a>{{task.taskStatusOperation}}</a></td>
					<td v-if="task.taskStatus!=0 && task.taskStatus!=1">{{task.taskStatusOperation}}</td>
				</tr>
			</tbody>
		</table>
		<!--分页组件开始-->
		<div>
			<pagination v-if="taskList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
		</div>
		<!--分页组件结束-->
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import Pagination from 'components/common/Pagination'
	export default {
		name: 'AppBackMission',
		components:{
			Pagination
		},
		data() {
			return {
				taskList:[],
				pageInfo:{}
			};
		},
		props:['stopped'],
		computed:mapState({
			userId : state => state.user.userId,
			canExport : state => state.home.canExport
		}),
		watch:{
			stopped(val){
				if(val){
					this.readMission()
				}
			},
			canExport(val){
				if(val){
					this.readMission()
				}
			}
		},
		beforeMount(){
			const param = {
				page_index:1
			}
			this.readMission(param)
		},
		beforeDestroy(){
			this.$store.dispatch('showMission',false)
		},
		methods:{
			readMission(param){
				this.$store.dispatch('exportTrack',false)
				this.$http.get(process.env.API_ROOT + '/home/backtask',{params:param})
				.then((res)=>{
					this.taskList = res.body.data.list
					const {pageNum,pages,total,isFirstPage,isLastPage} = res.body.data;
					this.pageInfo = {
									pageNum: pageNum,
									pages: pages,
									total: total,
									isFirstPage: isFirstPage,
									isLastPage: isLastPage
							}
				},(res)=>{
					this.$emit('openTip', res.body.message)
				})
				.catch((res)=>{
					this.$emit('openTip','请求异常')
				})
			},
			getPageNo(no){
				const param = {
					page_index:no
				}
				this.readMission(param)
			},
			stop(taskId){//中断
				this.$emit('stopTask',taskId)
			},
			download(uToken){//下载
				this.$store.dispatch('showMission',false)
				var path = process.env.EXPORT_PATH;
				var api = process.env.API_ROOT;
				//path  + api + '/noauth/export?url=' + uToken + '&path=' + this.groupId
				var fileName = path + api + '/noauth/export?url=' + uToken + '&path=' + this.userId
	    		var elemIF = document.createElement("iframe");   
			    elemIF.src = fileName;   
			    elemIF.style.display = "none";
			    document.body.appendChild(elemIF);  
			},
			closeComp(){
				this.$store.dispatch('showMission',false)
			}
		}
	};
</script>
<style scoped>
	.hand{text-decoration: underline;}
</style>


// WEBPACK FOOTER //
// BackMission.vue?62ccd97e